<div class="submitted mb-4">
    <input
        type="text"
        class="form-control"
        [(ngModel)]="newLinkedTicketId"
        placeholder="{{ 'Paste a new Ticket ID here' | translate }}"
        [required]="isSubmitted"
        pattern="^[0-9]*$"
        (keyup.enter)="addLinkedTicket(newLinkedTicketId, field.valid)"
        #field="ngModel"
        [ngClass]="{ 'ng-invalid': newLinkedTicketId && field.errors?.pattern }"
        appFocus
        [appAutoFocus]="isFocusNeeded" />
    @if (newLinkedTicketId && field.errors?.pattern) {
        <small class="top10 text-danger" translate> Should be a whole number </small>
    }

    @if (newLinkedTicketId && !field.errors) {
        <small class="text-light top10" translate> Press enter to link this ticket ID </small>
    }
</div>
<div>
    @for (linkedTicket of linkedTickets; track linkedTicket) {
        <div class="d-flex align-items-center w-100">
            <div class="text-break">
                #<a [routerLink]="[]" [queryParams]="{ ticketId: linkedTicket.ticketId }">{{ linkedTicket.ticketId }}</a
                >:
                {{ linkedTicket.title }}
            </div>
            <button
                class="btn btn-icon btn-close btn-transparent ms-auto"
                (click)="openRemoveLinkedTicketModal(linkedTicket.ticketId)">
                <sb-inline-svg
                    class="icon icon-close"
                    aria-label="My icon"
                    [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/X icon.svg'">
                </sb-inline-svg>
            </button>
        </div>
        <hr />
    }
</div>
@if (linkedTickets.length > 0) {
    <div class="d-flex justify-content-center">
        <a [routerLink]="[]" [queryParams]="{ linkedToTicket: ticket.id }">
            {{ 'Show all linked tickets in the ticket list' | translate }}
        </a>
    </div>
}
